export default __webpack_public_path__ + "static/media/Pickpocket's Gloves of the Swift Return.5667b792.jpg";